// extracted by mini-css-extract-plugin
module.exports = {"btnDiv":"Sixth_btnDiv__3YXoR","btn":"Sixth_btn__isx7M"};